
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmFire as ObiAlarmFireElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-fire.js';
 
 
 

 
 export const ObiAlarmFire = createComponent({
   react: React,
   tagName: 'obi-alarm-fire',
   elementClass: ObiAlarmFireElement,
   events: {
     
   }
  });
 
 